import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export default class TextImg {
  constructor(el) {
    this.el = el
    this.title = this.el.querySelector('.text-img--title')
    this.media = this.el.querySelector('.text-img--media')
    this.init()
  }

  init() {
    if (this.title) this.titleAnimation()
    if (this.media) this.imgAnimation()
  }

  imgAnimation() {
    gsap.set(this.media, { y: 60, opacity: 0 })

    gsap.to(this.media, {
      y: 0,
      opacity: 1,
      ease: 'power3.out',
      duration: 1.2,
      scrollTrigger: {
        trigger: this.media,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    })
  }

  titleAnimation() {
    const split = new SplitText(this.title, { type: 'words', mask: 'lines' })

    gsap.set(split.words, { y: 24, opacity: 0 })

    gsap.to(split.words, {
      y: 0,
      opacity: 1,
      stagger: 0.07,
      ease: 'power3.out',
      duration: 1,
      scrollTrigger: {
        trigger: this.title,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    })
  }
}
